// src/accounts/pages/AccountSettings.js
import React, { useMemo, useState } from "react";

// Pages shown inside Settings
import AccountMarketing from "./AccountMarketing";
import AccountProfile from "./AccountProfile";
import AccountHistory from "./AccountHistory";
import AccountOrders from "./AccountOrders";
import AccountBilling from "./AccountBilling";

export default function AccountSettings({
  user,
  subscriptionText,
  hasElementsAccess,
  onUpgrade,
  mode = "user",

  history = [],
  historyLoading = false,
  onReloadHistory,
  onClearHistory,
}) {
  const TABS = useMemo(
    () => mode === "admin"
      ? [
          { key: "profile", label: "Profile" },
          { key: "marketing", label: "Marketing" },
        ]
      : [
          { key: "marketing", label: "Marketing" },
          { key: "profile", label: "Profile" },
          { key: "activities", label: "Activities" },
          { key: "orders", label: "Order history" },
          { key: "billing", label: "Billing info" },
        ],
    [mode]
  );

  // ✅ Default tab: Marketing
  const [tab, setTab] = useState(mode === "admin" ? "profile" : "marketing");

  const btnStyle = (active) => ({
    ...linkBtn,
    background: active ? "#0b5360" : "#ffffff",
    color: active ? "#ffffff" : "#0b0b0b",
    border: active ? "1px solid rgba(0,0,0,0.08)" : "1px solid rgba(0,0,0,0.18)",
  });

  const onTabClick = (nextKey) => {
    setTab(nextKey);

    // ✅ reload activities when opening Activities
    if (nextKey === "activities") {
      onReloadHistory?.();
    }
  };

  return (
    <section className="acctPage">
      <h2 className="acctPageTitle">Settings</h2>

      <div style={linkWrap}>
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => onTabClick(t.key)}
            style={btnStyle(tab === t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div style={{ marginTop: 18 }}>
        {tab === "marketing" && <AccountMarketing user={user} />}

        {tab === "profile" && <AccountProfile user={user} />}

        {mode !== "admin" && tab === "activities" && (
          <>
            {historyLoading ? (
              <p className="acctMuted">Loading…</p>
            ) : (
              <AccountHistory history={history} onClear={onClearHistory} />
            )}
          </>
        )}

        {mode !== "admin" && tab === "orders" && <AccountOrders user={user} />}

        {mode !== "admin" && tab === "billing" && (
          <AccountBilling
            user={user}
            subscriptionText={subscriptionText}
            hasElementsAccess={hasElementsAccess}
            onUpgrade={onUpgrade}
          />
        )}
      </div>
    </section>
  );
}

const linkWrap = {
  display: "flex",
  gap: 12,
  flexWrap: "wrap",
  marginTop: 14,
};

const linkBtn = {
  padding: "6px 6px",
  borderRadius: 8,
  fontWeight: 900,
  cursor: "pointer",
  textAlign: "center",
};